import Controller from "csi/action/Controller";
import FormData from "csi/action/FormData";
import comm from "csi/comm";
import def from "csi/def";
import { Field } from "csi/def/Field";
import { writeFormFields } from "csi/service/writerService";
import csiView from "csi/view";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import apparel from "src/Apparel/main";

const PromoteToShape = declare([Controller, ActionControllerMixin], {

	fdShapeFormPage: null,
	fdSizeChartsPage: null,
	fdDocumentsPage: null,
	fdStylePage: null,
	LINK_TO_STYLE: "PromoteToShape_LinkToStyle",
	SHAPE_MASTER_NAME: "ShapeMasterName",
	SHAPE_SIZE_RANGE: "ShapeSizeRange",
	SHAPE_SEASONS: "ShapeSeasons",
	STYLE: "Style",
	bShowWait: true,
	fromStyle: null,


	isFromShapeAction: false,

	/** @override
	 * Set the fromStyle and isPromoteAction to the viewParams for ShapeForm on Promote and New Shape From Style
	 */
	onWizardViewPreCreate: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*csi.view.Widget*/view, viewParams) {
		const index = wizard.getIndexOfPage(page);
		if ((index == 0 && !this.isFromShapeAction) || (index == 1 && this.isFromShapeAction)) {
			viewParams.isPromoteAction = true;
		}
	},

	/**
	*@override
	* Prepare the data and pass it into the next page
	*/
	onNextPage(wizard, currentPage, nextPage, bFinish) {
		let fd: FormData = this.m_formData;
		const indexOfPage = wizard.getIndexOfPage(nextPage);
		if (!this.isFromShapeAction) {
			if (indexOfPage == 0) {
				fd = this.fdShapeFormPage = this.fdShapeFormPage || new FormData(this);
				this.fromStyle = this.getNode();
			} else if (indexOfPage == 1) {
				fd = this.fdSizeChartsPage = this.fdSizeChartsPage || new FormData(this);
			} else if (indexOfPage == 2) {
				fd = this.fdDocumentsPage = this.fdDocumentsPage || new FormData(this);
			}
		} else {
			if (indexOfPage == 0) {
				fd = this.fdStylePage = this.fdStylePage || new FormData(this);
				fd.m_bRequireOne = true;
				fd.m_bSelectOne = true;
			} else if (indexOfPage == 1) {
				this.fromStyle = wizard.getFormDataFromPage(currentPage)
					.getSelectedNode();
				fd = this.fdShapeFormPage = this.fdShapeFormPage || new FormData(this);
			} else if (indexOfPage == 2) {
				fd = this.fdSizeChartsPage = this.fdSizeChartsPage || new FormData(this);
			} else if (indexOfPage == 3) {
				fd = this.fdDocumentsPage = this.fdDocumentsPage || new FormData(this);
			}
			if (indexOfPage !== 0) {
				fd.setNode(this.fromStyle);
			}
		}
		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, (wizard.getIndexOfPage(nextPage) == 1)): null;
	},

	/**
	 * @override
	 * Disable Previous button on index 1 if the action is New Shape From Style
	 */
	disablePrev: function(wizard, page, index) {
		// prevent user from going back to first step of wizard by clicking on wizard card
		if (this.isFromShapeAction && index) {
			const selectStyleCard = wizard._getStepCardByIndex(0);
			selectStyleCard.setInactive(true);
			selectStyleCard.selectStep = function(): void {
				//do nothing
			};
		}
		return !index || (this.isFromShapeAction && index == 1);
	},

	/**
	 * @override
	 */
	toWriter: function () {
		const { fdShapeFormPage, LINK_TO_STYLE, SHAPE_MASTER_NAME, SHAPE_SEASONS, SHAPE_SIZE_RANGE, STYLE } = this;
		const linkToStyle = fdShapeFormPage.getFieldValue(LINK_TO_STYLE);
		const shapeMasterName = fdShapeFormPage.getFieldValue(SHAPE_MASTER_NAME);
		const shapeName = fdShapeFormPage.getFieldValue(xml.ATTR_NAME);
		const seasons = fdShapeFormPage.getFieldValue(SHAPE_SEASONS);
		const sizeRange = fdShapeFormPage.getFieldValue(SHAPE_SIZE_RANGE);
		const styleUrl = this.fromStyle.$URL;
		const shapeSecurityGroupUrl = this.getParent().$Type === "ShapeSecurityGroup" ? this.getParentURL() : null;
		this.m_urlNode = comm.createUrl();
		const defaultFields = [LINK_TO_STYLE, SHAPE_MASTER_NAME, xml.ATTR_NAME, SHAPE_SEASONS, SHAPE_SIZE_RANGE, STYLE];
		const customFields = fdShapeFormPage.getFields()
			.filter((field: Field) => !defaultFields.includes(field.getControlName()) && field.m_typeControl !== def.FIELD_COMMENT);
		
		const { m_writer: writer, m_urlNode } = this;	
		
		const call = writer.callMethod("ProductSpec", shapeSecurityGroupUrl === null ? "PromoteStyleToShape" : "PromoteStyleToShapeUnderSSG")
			.addParameter("URL", xml.ATTR_CNL, m_urlNode)
			.addParameter("LinkToStyle", xml.ATTR_BOOLEAN, linkToStyle)
			.addParameter("ShapeMasterName", xml.ATTR_STRING, shapeMasterName)
			.addParameter("ShapeName", xml.ATTR_STRING, shapeName)
			.addParameter("Seasons", xml.ATTR_REFLIST, seasons)
			.addParameter("SizeRange", xml.ATTR_REF, sizeRange)
			.addParameter("FromStyle", xml.ATTR_STRING, styleUrl)
			.addParameter("SizeCharts", xml.ATTR_REFLIST, this.fdSizeChartsPage.getSelectedValue())
			.addParameter("Documents", xml.ATTR_REFLIST, this.fdDocumentsPage.getSelectedValue());

		if (shapeSecurityGroupUrl !== null) {
			call.addParameter("ShapeSecurityGroup", xml.ATTR_STRING, shapeSecurityGroupUrl);
		}

		writeFormFields(writer, m_urlNode, customFields);
		this.setProgress();
	},

	postProcessSuccess: function() {
		// summary: refresh view when done if not already
		if (this.fdShapeFormPage.getFieldValue(this.LINK_TO_STYLE)) {
			apparel.refreshChildViewIfExists("SizeCharts");
			apparel.refreshChildViewIfExists("SizeChartReviews");
		}
		this.inherited(arguments);
	},
});

export = PromoteToShape;
